import { render, staticRenderFns } from "./ParagraphStructure.vue?vue&type=template&id=210c503a&scoped=true&"
import script from "./ParagraphStructure.vue?vue&type=script&lang=js&"
export * from "./ParagraphStructure.vue?vue&type=script&lang=js&"
import style0 from "./ParagraphStructure.vue?vue&type=style&index=0&id=210c503a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210c503a",
  null
  
)

export default component.exports